<section class="border-r border-gray-200 side-menu-container">
  <div class="flex items-center gap-3 px-5 border-b border-gray-300 select-none py-7">
    <img [src]="logo() || 'https://lepisode.team/assets/logo.svg'" class="h-8 w-auto object-contain" alt="logo" />
    <p class="text-xl font-semibold">
      {{ title() }}
    </p>
  </div>
  <div class="flex flex-col gap-1 overflow-y-auto scroll-none">
    <ng-content />
  </div>
</section>
